import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  decryptResponse,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const projectManagementServices = {
  addNewProjectSection,
  updateProjectSection,
  deleteProjectSection,
  addUpdateProjectTask,
  addUpdateProjectSubTask,
  getProjectManagementList,
  
  addNewProjectSubtaskComment,
  updateProjectSubtaskComment,
  deleteProjectSubtaskComment,
  getProjectSubtaskCommentList
};

// Add New Project Section
async function addNewProjectSection(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewProjectSection`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Project Section
async function updateProjectSection(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProjectSection`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Project Section
async function deleteProjectSection(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteProjectSection`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Add Update Project Task
async function addUpdateProjectTask(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateProjectTask`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Add Update Project Sub-Task
async function addUpdateProjectSubTask(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateProjectSubTask`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Get Project Management
async function getProjectManagementList(gpId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getProjectManagementList/${gpId}`;
  const response = await fetch(apiURL, headersWithAuthWithoutBody("GET", headers));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Add New Project Subtask Comment
async function addNewProjectSubtaskComment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewProjectSubtaskComment`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Project Subtask Comment
async function updateProjectSubtaskComment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProjectSubtaskComment`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Project Subtask Comment
async function deleteProjectSubtaskComment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteProjectSubtaskComment`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get Project Subtask Comment
async function getProjectSubtaskCommentList(gpId, sectionId, taskId, subTaskId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getProjectSubtaskCommentList/${gpId}/${sectionId}/${taskId}/${subTaskId}`;
  const response = await fetch(apiURL, headersWithAuthWithoutBody("GET", headers));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}